import React from 'react'
import Button_1 from "../../AComponent/Buttons/Button_1";
import '../M.css'

function EWButtonArray({ Actions }) {
    console.log("From BTN Array")
  return (
    <>
      <div className="flex" style={{ justifyContent: 'space-around' }}>
        {Actions.map((ele, index) => {
          function Handler() {
            console.log(ele.Feature_url)
          }

          return (
            <Button_1
              Type={ele.Type}
              Color={ele.Color}
              Title={ele.Title}
              Handler={Handler}
            />
          )
        })}
      </div>
    </>
  )
}

export default EWButtonArray;
